
// Import css files

import hammer from '../../../../../assets/images/hammer.png';
import React from 'react';
import { convertToCanadianDateTime, decodeHtmlEntities } from "../../../../../shared/helper";
import expiryclock from '../../../../../assets/images/expiryclock.svg';
const BankingArticleDetailsV3Jsx = (props) => {
  const {
    detailsData
  } = props;
  return (
    <>

<section className="bankinversionthreedetailblog">
        <div className="container">
          <div className="blogsectioone">
            <div className="row">
              <div className="col-lg-7 col-sm-7">
                <div className="blogsectiooneleft">
              
                  <div className="blogsectioleft">
                    <div className="title">
                      <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
                      <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.variant_3?.banner_sectionn?.short_description }}></div>                    
                  </div>
                  
                <div className="anptag"><p>{detailsData?.acf?.variant_3?.banner_sectionn.description }</p></div>
                <div className="d-flex userdetails">
                    <div className="userphoto">
                      <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                    </div>
                    <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
                  </div>
                  </div>
              </div>
              <div className="col-lg-5 col-sm-5">
                <div className="blogsectioright">
                  <img src={detailsData?.acf?.variant_3?.banner_sectionn?.image} alt="bannerimage" />
                  
                </div>
                <p className="articlepublishdate mt-2"><span><img src={expiryclock} alt="clock" /></span>{convertToCanadianDateTime(detailsData?.date)}</p>
              </div>
            </div>

          </div>
          <div className="blogsectiontwo">
            <div className="row">
              <div className="col-lg-4 col-sm-4">
                <div className="psnapshot">
                  <h2>Product Snapshot</h2>
                  <table className="table psnapshotin">
                    {detailsData?.acf?.variant_3?.product_snapshot.map((item,index) => (
                   <tr key={index}>
                     <td>{index+1}</td>
                     <td>{item?.title}:</td>
                     <td>{item?.value}</td>
                   </tr>
                   ))}
                  
                  </table>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4">
                <div className="prosinner">
                  <ul>
                  {detailsData?.acf?.variant_3?.product_pros.map((item,index) => (
                    <li key={index}>{item?.title}</li>
                    ))}
                   
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4">
                <div className="prosinner consinner">
                  <ul>
                  {detailsData?.acf?.variant_3?.product_cons.map((item,index) => (
                    <li key={index}>{item?.title}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="blogsectionthree">
            <div className="row">
              <div className="col-lg-3 col-sm-3">
                <h2>{detailsData?.acf?.variant_3?.features_section?.title}</h2>
              </div>
              <div className="col-lg-9 col-sm-9">
                <div className="blogsectionthreeright">
                  <div className="row">

                  {detailsData?.acf?.variant_3?.features_section?.features.map((item,index) => (
                    <div className="col" key={index}>
                      <div className="col-inner">
                        <div className="slnumber">{index+1}</div>
                        <div className="col-innerts">
                          <h4>{item?.title}</h4>
                          <p>{item?.description}</p>
                        </div>
                      </div>
                    </div>

                    ))}
                    
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="blogsectionfour">
            <div className="row">
              <div className="col-lg-9 col-sm-9">
                <div className="blogsectionfourinner">
                <h2>{detailsData?.acf?.variant_3?.ease_section?.title}</h2>
                  <div className="row">

                  {detailsData?.acf?.variant_3?.ease_section?.usecases.map((item,index) => (
                  <div className="col-lg-4 col-sm-4"  key={index}>
                  <div className="blogsectionfourleftinner">
                    <h4>{item?.title}</h4>
                    <p>{item?.description}</p>
                  </div>
                  </div>

                  ))}


                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3">
                <h3>{detailsData?.acf?.variant_3?.conclusion_section?.title}</h3>
                <img src={hammer} className="hammer" alt={hammer}/>
                <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.variant_3?.conclusion_section?.description }}></div>
                
              </div>
            </div>
          </div>
          <div className="blogsectionfive">
            <div className="row">
              <div className="col-lg-3 col-sm-3">
                <h2>{detailsData?.acf?.variant_3?.value_for_money?.title}</h2>
              </div>
              <div className="col-lg-9 col-sm-9">
                <div className="blogsectionfiveright">
                  <div className="row">

                  {detailsData?.acf?.variant_3?.value_for_money?.item.map((item,index) => (
                    <div className="blogsectionfiverightinner" key={index}>
                      <span>{String.fromCharCode(65 + index)}</span>
                      <p>{item?.description}</p>
                    </div>
                  ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>

  );
};

export default BankingArticleDetailsV3Jsx;